import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <div className="footer">
      <div className="footer__copyright">
        <span>© 2020 Copyright: Md Malek sarker limon</span>
      </div>
    </div>
  );
}

export default Footer;
